// @flow

import createAction            from 'redux-actions/lib/createAction';
import type { LocationRecord } from '../../modules/react-router/domain/react-router.domain';


// -----------------------------------------------------------------------------------------------------------------
// Types
// -----------------------------------------------------------------------------------------------------------------

export type AddPathToRouterHistoryActionType = 'ROUTER_HISTORY:ADD_PATH';

export type AddPathToRouterHistoryActionPayload = {|
  location: LocationRecord,
|};

export type AddPathToRouterHistoryActionMeta = {||};

export type AddPathToRouterHistoryActionArgs = {|
  location: LocationRecord,
|};

export type AddPathToRouterHistoryAction = {
  type: AddPathToRouterHistoryActionType,
  payload: AddPathToRouterHistoryActionPayload,
  meta: AddPathToRouterHistoryActionMeta,
};


// -----------------------------------------------------------------------------------------------------------------
// Constants
// -----------------------------------------------------------------------------------------------------------------

const type: AddPathToRouterHistoryActionType = 'ROUTER_HISTORY:ADD_PATH';


// -----------------------------------------------------------------------------------------------------------------
// Action
// -----------------------------------------------------------------------------------------------------------------

const addPathToRouterHistory: (AddPathToRouterHistoryActionArgs) => AddPathToRouterHistoryAction = createAction(
  type,
  ({location}: AddPathToRouterHistoryActionArgs) => ({location}),
);


// -----------------------------------------------------------------------------------------------------------------
// Exports
// -----------------------------------------------------------------------------------------------------------------

export default addPathToRouterHistory;



// WEBPACK FOOTER //
// ./src/actions/router/addPathToRouterHistory.js